class NyvoltNavigation extends HTMLElement {
  connectedCallback() {
    if (this.ready) return;
    this.ready = true;
    this.controller = new AbortController();
    this.panelHistory = [];
    const options = {signal:this.controller.signal};
    this.dialog = this.querySelector('[data-nv-drawer]');
    this.heading = this.querySelector('[data-nv-menu-title]');
    this.back = this.querySelector('[data-nv-menu-back]');
    this.mega = this.querySelector('[data-nv-mega]');
    this.desktop = window.matchMedia('(min-width:1101px)');
    this.finePointer = window.matchMedia('(hover:hover) and (pointer:fine)');
    this.openers = Array.from(this.querySelectorAll('[data-nv-menu-open]'));
    const syncMode = () => {
      this.closeMega(false);
      if (this.dialog.open) this.dialog.close();
      this.openers.forEach(button => {
        const usesMega = this.desktop.matches && button.dataset.nvMenuOpen !== 'root';
        button.setAttribute('aria-controls', usesMega ? this.mega.id : this.dialog.id);
        if (usesMega) button.removeAttribute('aria-haspopup');
        else button.setAttribute('aria-haspopup','dialog');
      });
    };
    this.desktop.addEventListener('change',syncMode,options);
    syncMode();
    this.addEventListener('click', event => {
      const open = event.target.closest('[data-nv-menu-open]');
      const panel = event.target.closest('[data-nv-panel-open]');
      if (open && open.tagName === 'A') {
        this.closeMega(false);
        return;
      }
      if (open) {
        if (this.desktop.matches && open.dataset.nvMenuOpen !== 'root') {
          if (!this.mega.hidden && this.opener === open && this.openedByClick) this.closeMega(false);
          else { this.openMega(open); this.openedByClick = true; }
        } else {
          this.closeMega(false);
          this.opener = open;
          this.panelHistory = [];
          this.showPanel(open.dataset.nvMenuOpen || 'root', false, false);
          this.dialog.showModal();
          open.setAttribute('aria-expanded','true');
          document.documentElement.classList.add('nv-menu-is-open');
        }
      } else if (event.target.closest('[data-nv-mega-close]')) {
        this.closeMega(true);
      } else if (panel) {
        this.panelTrigger = panel;
        this.showPanel(panel.dataset.nvPanelOpen,true);
      } else if (event.target.closest('[data-nv-menu-back]')) {
        const current = this.dialog.dataset.currentPanel;
        const previous = this.panelHistory.pop() || 'root';
        this.showPanel(previous,false,false);
        Array.from(this.querySelectorAll('[data-nv-panel-open]')).find(button => button.dataset.nvPanelOpen === current && !button.closest('[data-nv-panel]')?.hidden)?.focus();
      } else if (event.target.closest('[data-nv-menu-close]')) {
        this.dialog.close();
      } else if (event.target.closest('a')) {
        if (this.dialog.open) this.dialog.close();
        this.closeMega(false);
      } else if (event.target === this.dialog) {
        const rect = this.dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.dialog.close();
      }
    },options);
    this.openers.forEach(button => button.addEventListener('pointerenter', event => {
      if (button.dataset.nvMenuOpen !== 'root' && this.desktop.matches && this.finePointer.matches && event.pointerType !== 'touch') {
        clearTimeout(this.closeTimer);
        this.openedByClick = false;
        this.openMega(button);
      }
    },options));
    const cancelMegaClose = () => clearTimeout(this.closeTimer);
    const scheduleMegaClose = () => {
      if (this.desktop.matches && this.finePointer.matches) {
        clearTimeout(this.closeTimer);
        this.closeTimer = setTimeout(()=>{
          if (!this.matches(':hover') && !this.mega.matches(':hover') && !this.mega.contains(document.activeElement)) this.closeMega(false);
        },220);
      }
    };
    this.addEventListener('pointerenter',cancelMegaClose,options);
    this.addEventListener('pointerleave',scheduleMegaClose,options);
    this.mega.addEventListener('pointerenter',cancelMegaClose,options);
    this.mega.addEventListener('pointerleave',scheduleMegaClose,options);
    this.addEventListener('focusout',event=>{
      if (event.relatedTarget) {
        if (!this.contains(event.relatedTarget) && !this.matches(':hover') && !this.mega.matches(':hover')) this.closeMega(false);
        return;
      }
      setTimeout(()=>{ if (!this.contains(document.activeElement) && !this.matches(':hover') && !this.mega.matches(':hover')) this.closeMega(false); },0);
    },options);
    this.addEventListener('keydown',event=>{
      const localization = this.querySelector('.nv-menu-top .nv-localization details[open]');
      if (event.key === 'Escape' && localization) {
        event.preventDefault();
        event.stopPropagation();
        localization.open = false;
        localization.querySelector('summary')?.focus();
        return;
      }
      const trigger = event.target.closest('[data-nv-menu-open]');
      if (this.desktop.matches && trigger && event.key === 'ArrowDown') {
        event.preventDefault();
        this.openMega(trigger);
        this.mega.querySelector('[data-nv-category]:not([hidden]) a, [data-nv-discover]:not([hidden]) a, [data-nv-mega-family]:not([hidden]) a')?.focus();
        return;
      }
      if (!this.desktop.matches || this.mega.hidden) return;
      if (event.key === 'Escape') { event.preventDefault(); this.closeMega(true); }
      else if ((event.key === 'Tab' && !event.shiftKey || event.key === 'ArrowDown') && event.target === this.opener) {
        event.preventDefault();
        this.mega.querySelector('[data-nv-category]:not([hidden]) a, [data-nv-discover]:not([hidden]) a, [data-nv-mega-family]:not([hidden]) a')?.focus();
      } else if (event.key === 'Tab' && event.shiftKey && event.target === this.mega.querySelector('[data-nv-category]:not([hidden]) a, [data-nv-discover]:not([hidden]) a, [data-nv-mega-family]:not([hidden]) a')) {
        event.preventDefault();this.opener?.focus();
      }
    },options);
    document.addEventListener('pointerdown',event=>{
      if (!this.contains(event.target)) this.closeMega(false);
      const localization = this.querySelector('.nv-menu-top .nv-localization details[open]');
      if (localization && !localization.contains(event.target)) localization.open = false;
    },options);
    this.dialog.addEventListener('close',()=>{
      this.querySelectorAll('.nv-menu-top .nv-localization details[open]').forEach(details=>{details.open=false;});
      document.documentElement.classList.remove('nv-menu-is-open');
      this.openers.forEach(button=>button.setAttribute('aria-expanded','false'));
      this.opener?.focus();
    },options);
  }
  openMega(button) {
    clearTimeout(this.closeTimer);
    const family = button.dataset.nvMenuOpen || 'root';
    this.opener = button;
    const isDiscover = family === 'discover';
    const isCategory = ['electric-motorcycles','electric-scooters'].includes(family);
    this.mega.querySelectorAll('[data-nv-category]').forEach(panel => { panel.hidden = panel.dataset.nvCategory !== family; });
    this.mega.querySelector('.nv-mega-links').hidden = isCategory;
    this.mega.dataset.family = family;
    this.mega.querySelector('.nv-mega-grid').hidden = isDiscover || isCategory;
    this.mega.querySelector('[data-nv-discover]').hidden = !isDiscover;
    this.mega.querySelectorAll('[data-nv-collection]').forEach(link=>{link.hidden = isDiscover || link.dataset.nvCollection !== family;});
    this.mega.querySelectorAll('[data-nv-mega-family]').forEach(item=>{
      item.hidden = family === 'surron' ? !['ultra','light','hyper'].includes(item.dataset.nvMegaFamily) : family !== 'root' && item.dataset.nvMegaFamily !== family;
    });
    const title = this.mega.querySelector('[data-nv-mega-title]');
    title.textContent = family === 'root' ? title.dataset.defaultTitle : {surron:'Sur-Ron',ultra:'Ultra Bee',light:'Light Bee',hyper:'Hyper Bee','79bike':'79Bike','y-volt':'Y-VOLT'}[family] || button.closest('.nv-nav-category')?.querySelector('a')?.textContent.trim() || button.textContent.trim();
    this.mega.querySelector('.nv-mega-grid')?.setAttribute('aria-label', title.textContent);
    this.mega.hidden = false;
    this.openers.forEach(opener=>opener.setAttribute('aria-expanded',String(opener===button)));
  }
  closeMega(focus) {
    clearTimeout(this.closeTimer);
    if (!this.mega || this.mega.hidden) return;
    this.mega.hidden = true;
    this.openedByClick = false;
    this.openers.forEach(button=>button.setAttribute('aria-expanded','false'));
    if (focus) this.opener?.focus();
  }
  showPanel(id, focus, remember = true) {
    const current = this.dialog.dataset.currentPanel;
    if (remember && current && current !== id) this.panelHistory.push(current);
    const panels = Array.from(this.querySelectorAll('[data-nv-panel]'));
    const active = panels.find(panel=>panel.dataset.nvPanel===id) || panels[0];
    panels.forEach(panel=>{panel.hidden=panel!==active;});
    this.heading.textContent = active.dataset.nvTitle;
    this.back.hidden = active.dataset.nvPanel === 'root';
    this.dialog.dataset.currentPanel = active.dataset.nvPanel;
    active.scrollTop = 0;
    if (focus) this.heading.focus();
  }
  disconnectedCallback() {
    this.controller?.abort();
    clearTimeout(this.closeTimer);
    if (this.dialog?.open) this.dialog.close();
    document.documentElement.classList.remove('nv-menu-is-open');
    this.ready = false;
  }
}
if (!customElements.get('nyvolt-navigation')) customElements.define('nyvolt-navigation', NyvoltNavigation);
function revealNyvoltComparison() {
  if (window.location.hash === '#comparer') {
    const comparison = document.getElementById('comparer');
    if (comparison instanceof HTMLDetailsElement) comparison.open = true;
  }
}
revealNyvoltComparison();
window.addEventListener('hashchange', revealNyvoltComparison);
document.addEventListener('click', (event) => {
  const link = event.target.closest('a[href]');
  if (!link) return;
  const target = new URL(link.href, window.location.href);
  if (target.origin === window.location.origin && target.pathname === window.location.pathname && target.hash === '#comparer') {
    const comparison = document.getElementById('comparer');
    if (comparison instanceof HTMLDetailsElement) comparison.open = true;
  }
});


